import React from 'react';
import { crescentOutline } from './tableGeometry';

interface TableShapeGlyphProps {
    shape?: string;
    /** accessible text, e.g. "Crescent table" */
    label?: string;
}

const W = 60;
const H = 36;

const SHAPE_NAMES: Record<string, string> = {
    round: 'Round', oval: 'Oval', rect: 'Rectangular', rectangular: 'Long rectangular', crescent: 'Crescent',
};

export function shapeName(shape?: string): string {
    return SHAPE_NAMES[shape ?? 'round'] ?? 'Round';
}

/** Small read-only drawing of a table's shape, for lists and the shared view. */
export const TableShapeGlyph: React.FC<TableShapeGlyphProps> = ({ shape = 'round', label }) => {
    const title = label ?? `${shapeName(shape)} table`;
    let body: React.ReactNode;
    if (shape === 'crescent') {
        const pts = crescentOutline({ x: 4, y: 4, width: W - 8, height: H - 8 }, 'up')
            .map(p => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ');
        body = <polygon points={pts} />;
    } else if (shape === 'rect' || shape === 'rectangular') {
        body = <rect x={shape === 'rectangular' ? 4 : 12} y={shape === 'rectangular' ? 12 : 6} width={shape === 'rectangular' ? W - 8 : W - 24} height={shape === 'rectangular' ? 12 : 24} rx={2} />;
    } else if (shape === 'oval') {
        body = <ellipse cx={W / 2} cy={H / 2} rx={22} ry={13} />;
    } else {
        body = <circle cx={W / 2} cy={H / 2} r={14} />;
    }
    return (
        <svg className="fp-shape-glyph" width={48} height={29} viewBox={`0 0 ${W} ${H}`} role="img" aria-label={title} focusable="false">
            <title>{title}</title>
            {body}
        </svg>
    );
};

export default TableShapeGlyph;
